// import React, { useEffect, useRef, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import Product from "./Card";
// import { useCart } from "../../context/CartContext";
// import productAPI from "../../api/productApi";
// import Breadcrump from "../../components/Breadcrump";
// import SEO from "../../components/SEO";
// import KeyFeatures from "./detailfeatures/KeyFeatures";
// import ProductCard from "./Card";

// function DetailPage() {
//   const { slug } = useParams();
//   const { addToCart } = useCart();
//   const navigate = useNavigate();

//   const params = new URLSearchParams(window.location.search);

//   const thumbRef = useRef();

//   const [product, setProduct] = useState(null);
//   const [detail, setDetail] = useState(null);
//   const [variants, setVariants] = useState([]);
//   const [relatedProducts, setRelatedProducts] = useState([]);

//   const [selectedVariant, setSelectedVariant] = useState(null);
//   const [selectedAttributes, setSelectedAttributes] = useState({});

//   const [mainImage, setMainImage] = useState(null);
//   const [quantity, setQuantity] = useState(1);

//   const [showScrollIcon, setShowScrollIcon] = useState(false);

//   const [viewFixVideo, setViewFixVideo] = useState(false);

//   const [title, setTitle] = useState();
//   const [brand, setBrand] = useState({});
//   const [skuCode, setSkuCode] = useState("");
//   const [category, setCategory] = useState({});
//   const [description, setDescription] = useState("");
//   const [stock, setStock] = useState("");

//   /******************* FETCH PRODUCT *******************/
//   const fetchProductDetail = async () => {
//     try {
//       const res = await productAPI.details(slug);

//       if (res.code === 200) {
//         const { product, detail, brand, category, variants, relatedProducts } =
//           res.data;

//         setProduct(product);
//         setDetail(detail);
//         setBrand(brand);
//         setCategory(category);
//         setVariants(variants || []);
//         setRelatedProducts(relatedProducts || []);

//         setTitle(product?.title);
//         setSkuCode(product?.skuCode);
//         setDescription(detail?.description);

//         // default variant
//         if (variants?.length > 0) {
//           setSelectedVariant(variants[0]);
//         }

//         // images
//         const images = [];
//         if (product?.thumbnail) {
//           images.push(product.thumbnail);
//         }

//         if (detail?.images?.length) {
//           images.push(...detail.images.map((i) => i.url));
//         }

//         if (variants?.length) {
//           variants.forEach((v) => {
//             if (v.images?.length) {
//               images.push(...v.images.map((i) => i.url));
//             }
//           });
//         }

//         if (images.length > 0) {
//           setMainImage(images[0]);
//         }
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     fetchProductDetail();
//   }, [slug]);

//   /******************* IMAGES *******************/
//   const mergedImages = [
//     ...(product?.thumbnail ? [product.thumbnail] : []),
//     ...(detail?.images?.map((i) => i) || []),
//     ...variants.flatMap((v) => v.images || []),
//   ];

//   /******************* VARIANT ATTRIBUTES *******************/
//   const attributeMap = {};

//   variants.forEach((variant) => {
//     Object.entries(variant.attributes || {}).forEach(([key, value]) => {
//       if (!attributeMap[key]) {
//         attributeMap[key] = new Set();
//       }

//       attributeMap[key].add(value);
//     });
//   });

//   const handleVariantClick = (key, value) => {
//     const updated = {
//       ...selectedAttributes,
//       [key]: value,
//     };

//     setSelectedAttributes(updated);

//     const matched = variants.find((v) =>
//       Object.entries(updated).every(([k, val]) => v.attributes?.[k] === val),
//     );

//     if (matched) {
//       setSelectedVariant(matched);

//       if (matched.images?.length) {
//         setMainImage(matched.images[0].url);
//       }
//     }
//   };

//   // Create attribute map
//   if (variants) {
//     variants.forEach((variant) => {
//       if (variant.attributes && typeof variant.attributes === "object") {
//         Object.entries(variant.attributes).forEach(([key, value]) => {
//           if (!attributeMap[key]) {
//             attributeMap[key] = new Set();
//           }
//           attributeMap[key].add(value);
//         });
//       }
//     });
//   }

//   // Set default attributes on mount
//   useEffect(() => {
//     const defaultSelected = {};
//     Object.entries(attributeMap).forEach(([key, valueSet]) => {
//       const values = Array.from(valueSet);
//       if (values.length > 0) {
//         defaultSelected[key] = values[0];
//       }
//     });

//     setSelectedAttributes(defaultSelected);
//   }, []);

//   const extractYouTubeID = (url) => {
//     const regExp = /(?:youtube\.com.*(?:\?|&)v=|youtu\.be\/)([^&?/]+)/;
//     const match = url.match(regExp);
//     return match ? match[1] : null;
//   };

//   // to fix bottom
//   useEffect(() => {
//     const handleScroll = () => {
//       const quantityEl = document.querySelector(".action-btn-detail");
//       const stickyEl = document.querySelector(".tf-sticky-btn-atc");
//       const floatingVideo = document.querySelector(".floating-animate");

//       if (!quantityEl || !stickyEl || !floatingVideo) return;

//       const quantityBottom = quantityEl.getBoundingClientRect().bottom;
//       const windowHeight = window.innerHeight;

//       if (quantityBottom <= windowHeight) {
//         stickyEl.classList.remove("show");
//         floatingVideo.classList.add("active");
//       } else {
//         stickyEl.classList.add("show");
//         floatingVideo.classList.remove("active");
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     handleScroll();

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   useEffect(() => {
//     const checkScroll = () => {
//       const el = thumbRef.current;
//       if (el && el.scrollHeight > el.clientHeight) {
//         setShowScrollIcon(true);
//       } else {
//         setShowScrollIcon(false);
//       }
//     };

//     checkScroll();
//     window.addEventListener("resize", checkScroll);

//     return () => window.removeEventListener("resize", checkScroll);
//   }, [mergedImages]);

//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const preSelectedAttributes = {};

//     for (const [key, value] of params.entries()) {
//       preSelectedAttributes[key] = value;
//     }

//     if (Object.keys(preSelectedAttributes).length > 0 && variants.length > 0) {
//       setSelectedAttributes(preSelectedAttributes);

//       const matched = variants.find((variant) =>
//         Object.entries(preSelectedAttributes).every(
//           ([key, val]) => variant.attributes?.[key] === val,
//         ),
//       );

//       if (matched) {
//         setSelectedVariant(matched);
//         setTitle(`${product?.title} - ${matched.variant_name}`);
//         setSkuCode(matched.sku || product?.skuCode);
//         setDescription(matched.description || detail?.description);

//         const variantDetailImages = matched.images
//           ? matched.images.map((img) => img)
//           : [];

//         const mergedImages = [...variantDetailImages];

//         if (mergedImages.length > 0) {
//           setMainImage(mergedImages[0]);
//         }
//       }
//     }
//   }, [variants]);

//   /******************* CART *******************/
//   const handleAddToCart = (e) => {
//     const action = e.currentTarget.dataset.action;

//     try {
//       addToCart(product._id, quantity, selectedVariant?._id);

//       if (action === "buy-now") {
//         navigate("/checkout");
//       }
//     } catch (err) {
//       console.error("Add to cart error:", err);
//     }
//   };

//   /******************* THUMB SCROLL *******************/

//   useEffect(() => {
//     const checkScroll = () => {
//       const el = thumbRef.current;

//       if (!el) return;

//       if (el.scrollHeight > el.clientHeight) {
//         setShowScrollIcon(true);
//       } else {
//         setShowScrollIcon(false);
//       }
//     };

//     checkScroll();

//     window.addEventListener("resize", checkScroll);

//     return () => window.removeEventListener("resize", checkScroll);
//   }, [mergedImages]);

//   /******************* LOADING *******************/
//   if (!product) return <div className="container mt-5">Loading...</div>;

//   /************* FUNCTIONS FOR DEFINE*****************/
//   const price = selectedVariant
//     ? selectedVariant.price
//     : product?.productType === "Variant"
//       ? detail?.pricing?.minPrice
//       : detail?.pricing?.minPrice;

//   const inStock = selectedVariant ? Number(selectedVariant.stock) > 0 : true;

//   return (
//     <>
//       <Breadcrump title={product?.title} />
//       <SEO meta={detail?.meta} />

//       <section className="bento-section">
//         <div className="container">
//           <div className="row g-4">
//             <div className="col-lg-5">
//               <div className="bento-card image-card">
//                 <img src={mainImage} alt="Product Main" className="main-img" />
//                 <span className="tag-badge">Best Seller</span>
//               </div>
//               <div className="row g-3 mt-1">
//                 {mergedImages.map((img, idx) => (
//                   <div className="col-6">
//                     <div className="bento-card mini-card">
//                       <img src={img} alt="Texture" />
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div className="col-lg-7">
//               <div className="row g-4">
//                 {/* Description Box */}
//                 <div className="col-12">
//                   <div className="bento-card desc-card">
//                     {brand && (
//                       <span className="brand-product ">
//                         <Link
//                           className="brand-product  custom-detail-section"
//                           to={`/brands/${brand?.slug}`}
//                         >
//                           <h3> {brand?.name}</h3>
//                         </Link>
//                       </span>
//                     )}

//                     <h3>{title}</h3>
//                     <p>{detail.shortDescription}</p>

//                     <div className="product-price">
//                       {selectedVariant ? (
//                         <>
//                           <div className="display-sm price-new">
//                             ₹{selectedVariant?.price?.toFixed(2)}
//                           </div>
//                           {selectedVariant?.mrp &&
//                             selectedVariant?.mrp > selectedVariant.price && (
//                               <>
//                                 <div className="display-sm price-old">
//                                   ₹{selectedVariant?.mrp?.toFixed(2)}
//                                 </div>
//                                 <span className="badge-sale">
//                                   {Math.round(
//                                     ((selectedVariant.mrp -
//                                       selectedVariant.price) /
//                                       selectedVariant.mrp) *
//                                       100,
//                                   )}
//                                   % Off
//                                 </span>
//                               </>
//                             )}
//                         </>
//                       ) : (
//                         <div className="display-sm price-new">₹{price}</div>
//                       )}
//                     </div>

//                     {(product.skuCode || category) && (
//                       <div className="item">
//                         <ul>
//                           {product.skuCode && (
//                             <li>
//                               <b>SKU:</b> {product.skuCode}
//                             </li>
//                           )}
//                           {category && (
//                             <li>
//                               <b>Category:</b>{" "}
//                               <Link
//                                 to={`/categories/${category?.slug}`}
//                                 className="custom-detail-sec"
//                               >
//                                 {category.name}
//                               </Link>
//                             </li>
//                           )}
//                         </ul>
//                       </div>
//                     )}

//                     <div className="product-stock">
//                       {selectedVariant && selectedVariant.stock > 0 ? (
//                         <span className="stock in-stock">In Stock</span>
//                       ) : (
//                         <span className="stock out-stock">Out of Stock</span>
//                       )}
//                     </div>

//                     {/* variant stock hurry */}
//                     {selectedVariant && selectedVariant.stock <= 100 && (
//                       <div className="product-progress-sale">
//                         <div className="title-hurry-up">
//                           <span className="text-primary fw-medium  text-dark">
//                             HURRY UP!
//                           </span>{" "}
//                           Only{" "}
//                           <span className="count">{selectedVariant.stock}</span>{" "}
//                           items left!
//                         </div>
//                       </div>
//                     )}

//                     <hr />

//                     {detail?.shortDescription && (
//                       <p className="short-description">
//                         {detail?.shortDescription}
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 {/* Size & Action Box */}
//                 <div className="col-12">
//                   <div className="bento-card action-card">
//                     <div className="selector-row">
//                       <div className="size-group">
//                         <span className="label">Size:</span>
//                         {/* <div className="size-btns">
//                           {["30ml", "50ml", "Refill"].map((size) => (
//                             <button
//                               key={size}
//                               className={activeSize === size ? "active" : ""}
//                               onClick={() => setActiveSize(size)}
//                             >
//                               {size}
//                             </button>
//                           ))}
//                         </div> */}

//                         {Object.entries(attributeMap).map(
//                           ([attrKey, values]) => {
//                             const valueArray = [...values];

//                             return (
//                               <div
//                                 className="variant-size variant-picker-item"
//                                 key={attrKey}
//                               >
//                                 <div className="variant-picker-label">
//                                   {attrKey.replace(
//                                     "variantAttribute",
//                                     "Option",
//                                   )}
//                                   :{" "}
//                                   <span className="variant-picker-label-value">
//                                     {selectedAttributes[attrKey] || "Select"}
//                                   </span>
//                                 </div>

//                                 <div className="variant-picker-values">
//                                   {valueArray.map((value, index) => {
//                                     const inputId = `${attrKey}-${value}-${index}`;
//                                     return (
//                                       <label
//                                         key={value}
//                                         htmlFor={inputId}
//                                         className={`variant-btn check-ship ${
//                                           selectedAttributes[attrKey] === value
//                                             ? "active"
//                                             : ""
//                                         }`}
//                                       >
//                                         <input
//                                           type="radio"
//                                           id={inputId}
//                                           name={attrKey}
//                                           className="tf-check-rounded"
//                                           value={value}
//                                           checked={
//                                             selectedAttributes[attrKey] ===
//                                             value
//                                           }
//                                           onChange={() =>
//                                             handleVariantClick(attrKey, value)
//                                           }
//                                         />
//                                         <span className="text text-sm">
//                                           <span>{value}</span>
//                                         </span>
//                                       </label>
//                                     );
//                                   })}
//                                 </div>
//                               </div>
//                             );
//                           },
//                         )}
//                       </div>

//                       <div className="qty-group">
//                         <span className="label">Qty:</span>
//                         <div className="qty-ctrl">
//                           <button
//                             className="btn-quantity btn-decrease"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               if (quantity > 1) setQuantity(quantity - 1);
//                             }}
//                           >
//                             -
//                           </button>
//                           <input
//                             className="quantity-product"
//                             type="text"
//                             name="number"
//                             value={quantity}
//                             readOnly
//                           />
//                           <button
//                             className="btn-quantity btn-increase"
//                             onClick={(e) => setQuantity(quantity + 1)}
//                           >
//                             +
//                           </button>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="btn-row">
//                       <button className="btn-bento-add">
//                         Add to Cart — ₹{(quantity * price).toLocaleString()}
//                       </button>
//                     </div>

//                     <div className="shipping-info">
//                       <span>🚚 Free Shipping</span>
//                       <span>🐰 Cruelty Free</span>
//                       <span>🌿 Organic</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="row mt-5">
//               <div className="col-lg-12">
//                 <div className="bento-card desc-card">
//                   {detail?.keyFeatures?.length > 0 && (
//                     <KeyFeatures item={detail.keyFeatures} />
//                   )}

//                   <div
//                     dangerouslySetInnerHTML={{ __html: description }}
//                     style={{ fontFamily: "sans-serif", lineHeight: 1.6 }}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {relatedProducts && relatedProducts.length > 0 && (
//         <div className="flat-spacing-2" style={{ backgroundColor: "beige" }}>
//           <div className="container product">
//             <div className="flat-animate-tab flat-controltab-nav">
//               <div className="flat-title text-start">
//                 <h4>Related Products</h4>
//               </div>
//               <div className="row">
//                 {relatedProducts.map((product, index) => (
//                   <div
//                     className="col-lg-3 col-sm-6 col-xs-6 mb-2"
//                     key={product?._id || index}
//                   >
//                     <Product item={product} />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {detail.video && (
//         <div id="floating-video" className="floating-animate">
//           <button
//             onClick={() => {
//               document.getElementById("floating-video").style.display = "none";
//               setViewFixVideo(true);
//             }}
//           >
//             ×
//           </button>
//           {detail.video.includes("youtube.com") ||
//           detail.video.includes("youtu.be") ? (
//             <iframe
//               width="100%"
//               height="180"
//               src={`https://www.youtube.com/embed/${extractYouTubeID(detail.video)}`}
//               allow="autoplay; encrypted-media"
//               allowFullScreen
//               title="YouTube video"
//             ></iframe>
//           ) : (
//             <video width="100%" height="180" controls autoPlay muted>
//               <source src={detail.video} type="video/mp4" />
//               Your browser does not support HTML5 video.
//             </video>
//           )}
//         </div>
//       )}


//        <div className="offcanvas offcanvas-end" id="cartDrawer" tabIndex="-1">
//         <CartCanvas />
//       </div>

//       <div className="tf-sticky-btn-atc show">
//         <div className="container-2">
//           <div className="tf-height-observer w-100 d-flex align-items-center">
//             <div className="tf-sticky-atc-product d-flex align-items-center">
//               <div className="tf-sticky-atc-img">
//                 <img src={mainImage} />
//               </div>
//               <div className="tf-sticky-atc-title fw-5 ">{title}</div>
//             </div>
//             <div
//               className="tf-sticky-atc-infos"
//               style={{ display: "contents" }}
//             >
//               {product?.productType !== "Single" && (
//                 <div className="tf-sticky-atc-variant-price text-center tf-select">
//                   <select>
//                     {variants.map((variant, index) => (
//                       <option key={index}>{variant?.attributes?.colour}</option>
//                     ))}
//                   </select>
//                 </div>
//               )}

//               <div className="tf-sticky-atc-btns">
//                 {/* <div className="tf-product-info-quantity">
//                   <div className="wg-quantity">
//                     <button
//                       className="btn-quantity minus-btn"
//                       className="qty-btn"
//                       onClick={(e) => setQuantity(quantity - 1)}
//                     >
//                       -
//                     </button>
//                     <input
//                       className="quantity-product font-4"
//                       type="text"
//                       name="number"
//                       value={quantity}
//                       readOnly
//                     />
//                     <button
//                       className="btn-quantity plus-btn  btn-increase"
//                       onClick={(e) => setQuantity(quantity + 1)}
//                     >
//                       +
//                     </button>
//                   </div>
//                 </div> */}
//                 <div className="custom-cart-qty-toggle">
//                   <button
//                     className="btn-quantity btn-decrease"
//                     onClick={(e) => {
//                       e.preventDefault();
//                       if (quantity > 1) setQuantity(quantity - 1);
//                     }}
//                   >
//                     -
//                   </button>
//                   <input
//                     // className="quantity-product"
//                     type="text"
//                     name="number"
//                     value={quantity}
//                     readOnly
//                   />
//                   <button
//                     className="btn-quantity btn-increase"
//                     onClick={(e) => setQuantity(quantity + 1)}
//                   >
//                     +
//                   </button>
//                 </div>

//                 <a
//                   href="#shoppingCartCanvas"
//                   data-action="cart"
//                   data-bs-toggle="offcanvas"
//                   data-bs-target="#cartDrawer"
//                   onClick={handleAddToCart}
//                   className="tf-btn animate-btn d-inline-flex justify-content-center"
//                 >
//                   Add to cart
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default DetailPage;







import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Product from "./Card";
import { useCart } from "../../context/CartContext";
import productAPI from "../../api/productApi";
import Breadcrump from "../../components/Breadcrump";
import SEO from "../../components/SEO";
import KeyFeatures from "./detailfeatures/KeyFeatures";
import ProductCard from "./Card";
import CartCanvas from "../canvas/CartCanvas";

function DetailPage() {
  const { slug } = useParams();
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);

  const thumbRef = useRef();

  const [product, setProduct] = useState(null);
  const [detail, setDetail] = useState(null);
  const [variants, setVariants] = useState([]);
  const [relatedProducts, setRelatedProducts] = useState([]);

  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedAttributes, setSelectedAttributes] = useState({});

  const [mainImage, setMainImage] = useState(null);
  const [quantity, setQuantity] = useState(1);

  const [showScrollIcon, setShowScrollIcon] = useState(false);

  const [viewFixVideo, setViewFixVideo] = useState(false);

  const [title, setTitle] = useState();
  const [brand, setBrand] = useState({});
  const [skuCode, setSkuCode] = useState("");
  const [category, setCategory] = useState({});
  const [description, setDescription] = useState("");
  const [stock, setStock] = useState("");

  /******************* FETCH PRODUCT *******************/
  const fetchProductDetail = async () => {
    try {
      const res = await productAPI.details(slug);

      if (res.code === 200) {
        const { product, detail, brand, category, variants, relatedProducts } =
          res.data;

        setProduct(product);
        setDetail(detail);
        setBrand(brand);
        setCategory(category);
        setVariants(variants || []);
        setRelatedProducts(relatedProducts || []);

        setTitle(product?.title);
        setSkuCode(product?.skuCode);
        setDescription(detail?.description);

        // default variant
        if (variants?.length > 0) {
          setSelectedVariant(variants[0]);
        }

        // images
        const images = [];
        if (product?.thumbnail) {
          images.push(product.thumbnail);
        }

        if (detail?.images?.length) {
          images.push(...detail.images.map((i) => i.url));
        }

        if (variants?.length) {
          variants.forEach((v) => {
            if (v.images?.length) {
              images.push(...v.images.map((i) => i.url));
            }
          });
        }

        if (images.length > 0) {
          setMainImage(images[0]);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProductDetail();
  }, [slug]);

  /******************* IMAGES *******************/
  const mergedImages = [
    ...(product?.thumbnail ? [product.thumbnail] : []),
    ...(detail?.images?.map((i) => i) || []),
    ...variants.flatMap((v) => v.images || []),
  ];

  /******************* VARIANT ATTRIBUTES *******************/
  const attributeMap = {};

  variants.forEach((variant) => {
    Object.entries(variant.attributes || {}).forEach(([key, value]) => {
      if (!attributeMap[key]) {
        attributeMap[key] = new Set();
      }

      attributeMap[key].add(value);
    });
  });

  const handleVariantClick = (key, value) => {
    const updated = {
      ...selectedAttributes,
      [key]: value,
    };

    setSelectedAttributes(updated);

    const matched = variants.find((v) =>
      Object.entries(updated).every(([k, val]) => v.attributes?.[k] === val),
    );

    if (matched) {
      setSelectedVariant(matched);

      if (matched.images?.length) {
        setMainImage(matched.images[0].url);
      }
    }
  };

  // Create attribute map
  if (variants) {
    variants.forEach((variant) => {
      if (variant.attributes && typeof variant.attributes === "object") {
        Object.entries(variant.attributes).forEach(([key, value]) => {
          if (!attributeMap[key]) {
            attributeMap[key] = new Set();
          }
          attributeMap[key].add(value);
        });
      }
    });
  }

  // Set default attributes on mount
  useEffect(() => {
    const defaultSelected = {};
    Object.entries(attributeMap).forEach(([key, valueSet]) => {
      const values = Array.from(valueSet);
      if (values.length > 0) {
        defaultSelected[key] = values[0];
      }
    });

    setSelectedAttributes(defaultSelected);
  }, []);

  const extractYouTubeID = (url) => {
    const regExp = /(?:youtube\.com.*(?:\?|&)v=|youtu\.be\/)([^&?/]+)/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  };

  // to fix bottom
  useEffect(() => {
    const handleScroll = () => {
      const firstBtn = document.querySelector(".action-card"); // 👈 main add to cart section
      const stickyEl = document.querySelector(".tf-sticky-btn-atc");
      const footer = document.querySelector("footer"); // 👈 last section

      if (!firstBtn || !stickyEl) return;

      const rect = firstBtn.getBoundingClientRect();

      const isFirstVisible = rect.top <= window.innerHeight && rect.bottom >= 0;

      let isFooterVisible = false;

      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        isFooterVisible = footerRect.top <= window.innerHeight;
      }

      // 🔥 FINAL CONDITIONS
      if (isFirstVisible || isFooterVisible) {
        stickyEl.classList.remove("show"); // ❌ hide
      } else {
        stickyEl.classList.add("show"); // ✅ show
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const checkScroll = () => {
      const el = thumbRef.current;
      if (el && el.scrollHeight > el.clientHeight) {
        setShowScrollIcon(true);
      } else {
        setShowScrollIcon(false);
      }
    };

    checkScroll();
    window.addEventListener("resize", checkScroll);

    return () => window.removeEventListener("resize", checkScroll);
  }, [mergedImages]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const preSelectedAttributes = {};

    for (const [key, value] of params.entries()) {
      preSelectedAttributes[key] = value;
    }

    if (Object.keys(preSelectedAttributes).length > 0 && variants.length > 0) {
      setSelectedAttributes(preSelectedAttributes);

      const matched = variants.find((variant) =>
        Object.entries(preSelectedAttributes).every(
          ([key, val]) => variant.attributes?.[key] === val,
        ),
      );

      if (matched) {
        setSelectedVariant(matched);
        setTitle(`${product?.title} - ${matched.variant_name}`);
        setSkuCode(matched.sku || product?.skuCode);
        setDescription(matched.description || detail?.description);

        const variantDetailImages = matched.images
          ? matched.images.map((img) => img)
          : [];

        const mergedImages = [...variantDetailImages];

        if (mergedImages.length > 0) {
          setMainImage(mergedImages[0]);
        }
      }
    }
  }, [variants]);

  /******************* CART *******************/
  const handleAddToCart = (e) => {
    const action = e.currentTarget.dataset.action;

    try {
      addToCart(product._id, quantity, selectedVariant?._id);

      if (action === "buy-now") {
        navigate("/checkout");
      }
    } catch (err) {
      console.error("Add to cart error:", err);
    }
  };

  /******************* THUMB SCROLL *******************/

  useEffect(() => {
    const checkScroll = () => {
      const el = thumbRef.current;

      if (!el) return;

      if (el.scrollHeight > el.clientHeight) {
        setShowScrollIcon(true);
      } else {
        setShowScrollIcon(false);
      }
    };

    checkScroll();

    window.addEventListener("resize", checkScroll);

    return () => window.removeEventListener("resize", checkScroll);
  }, [mergedImages]);

  /******************* LOADING *******************/
  if (!product) return <div className="container mt-5">Loading...</div>;

  /************* FUNCTIONS FOR DEFINE*****************/
  const price = selectedVariant
    ? selectedVariant.price
    : product?.productType === "Variant"
      ? detail?.pricing?.minPrice
      : detail?.pricing?.minPrice;

  const inStock = selectedVariant ? Number(selectedVariant.stock) > 0 : true;

  return (
    <>
      <Breadcrump title={product?.title} />
      <SEO meta={detail?.meta} />

      <section className="bento-section">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-5">
              <div className="bento-card image-card">
                <img src={mainImage} alt="Product Main" className="main-img" />
                <span className="tag-badge">Best Seller</span>
              </div>
              <div className="row g-3 mt-1">
                {mergedImages.map((img, idx) => (
                  <div className="col-6">
                    <div className="bento-card mini-card">
                      <img src={img} alt="Texture" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-7">
              <div className="row g-4">
                {/* Description Box */}
                <div className="col-12">
                  <div className="bento-card desc-card">
                    {brand && (
                      <span className="brand-product ">
                        <Link
                          className="brand-product  custom-detail-section"
                          to={`/brands/${brand?.slug}`}
                        >
                          <h3> {brand?.name}</h3>
                        </Link>
                      </span>
                    )}

                    <h3>{title}</h3>
                    <p>{detail.shortDescription}</p>

                    <div className="product-price">
                      {selectedVariant ? (
                        <>
                          <div className="display-sm price-new">
                            ₹{selectedVariant?.price?.toFixed(2)}
                          </div>
                          {selectedVariant?.mrp &&
                            selectedVariant?.mrp > selectedVariant.price && (
                              <>
                                <div className="display-sm price-old">
                                  ₹{selectedVariant?.mrp?.toFixed(2)}
                                </div>
                                <span className="badge-sale">
                                  {Math.round(
                                    ((selectedVariant.mrp -
                                      selectedVariant.price) /
                                      selectedVariant.mrp) *
                                      100,
                                  )}
                                  % Off
                                </span>
                              </>
                            )}
                        </>
                      ) : (
                        <div className="display-sm price-new">₹{price}</div>
                      )}
                    </div>

                    {(product.skuCode || category) && (
                      <div className="item">
                        <ul>
                          {product.skuCode && (
                            <li>
                              <b>SKU:</b> {product.skuCode}
                            </li>
                          )}
                          {category && (
                            <li>
                              <b>Category:</b>{" "}
                              <Link
                                to={`/categories/${category?.slug}`}
                                className="custom-detail-sec"
                              >
                                {category.name}
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    )}

                    <div className="product-stock">
                      {selectedVariant && selectedVariant.stock > 0 ? (
                        <span className="stock in-stock">In Stock</span>
                      ) : (
                        <span className="stock out-stock">Out of Stock</span>
                      )}
                    </div>

                    {/* variant stock hurry */}
                    {selectedVariant && selectedVariant.stock <= 100 && (
                      <div className="product-progress-sale">
                        <div className="title-hurry-up">
                          <span className="text-primary fw-medium  text-dark">
                            HURRY UP!
                          </span>{" "}
                          Only{" "}
                          <span className="count">{selectedVariant.stock}</span>{" "}
                          items left!
                        </div>
                      </div>
                    )}

                    <hr />

                    {detail?.shortDescription && (
                      <p className="short-description">
                        {detail?.shortDescription}
                      </p>
                    )}
                  </div>
                </div>

                {/* Size & Action Box */}
                <div className="col-12">
                  <div className="bento-card action-card">
                    <div className="selector-row">
                      <div className="size-group">
                        <span className="label">Size:</span>
                        {/* <div className="size-btns">
                          {["30ml", "50ml", "Refill"].map((size) => (
                            <button
                              key={size}
                              className={activeSize === size ? "active" : ""}
                              onClick={() => setActiveSize(size)}
                            >
                              {size}
                            </button>
                          ))}
                        </div> */}

                        {Object.entries(attributeMap).map(
                          ([attrKey, values]) => {
                            const valueArray = [...values];

                            return (
                              <div
                                className="variant-size variant-picker-item"
                                key={attrKey}
                              >
                                <div className="variant-picker-label">
                                  {attrKey.replace(
                                    "variantAttribute",
                                    "Option",
                                  )}
                                  :{" "}
                                  <span className="variant-picker-label-value">
                                    {selectedAttributes[attrKey] || "Select"}
                                  </span>
                                </div>

                                <div className="variant-picker-values">
                                  {valueArray.map((value, index) => {
                                    const inputId = `${attrKey}-${value}-${index}`;
                                    return (
                                      <label
                                        key={value}
                                        htmlFor={inputId}
                                        className={`variant-btn check-ship ${
                                          selectedAttributes[attrKey] === value
                                            ? "active"
                                            : ""
                                        }`}
                                      >
                                        <input
                                          type="radio"
                                          id={inputId}
                                          name={attrKey}
                                          className="tf-check-rounded"
                                          value={value}
                                          checked={
                                            selectedAttributes[attrKey] ===
                                            value
                                          }
                                          onChange={() =>
                                            handleVariantClick(attrKey, value)
                                          }
                                        />
                                        <span className="text text-sm">
                                          <span>{value}</span>
                                        </span>
                                      </label>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          },
                        )}
                      </div>

                      <div className="qty-group">
                        <span className="label">Qty:</span>
                        <div className="custom-cart-qty-toggle">
                          <button
                            className="btn-quantity btn-decrease"
                            onClick={(e) => {
                              e.preventDefault();
                              if (quantity > 1) setQuantity(quantity - 1);
                            }}
                          >
                            -
                          </button>
                          <input
                            // className="quantity-product"
                            type="text"
                            name="number"
                            value={quantity}
                            readOnly
                          />
                          <button
                            className="btn-quantity btn-increase"
                            onClick={(e) => setQuantity(quantity + 1)}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="btn-row">
                      <button
                        className="btn-bento-add"
                        data-action="cart"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#cartDrawer"
                        onClick={handleAddToCart}
                      >
                        Add to Cart — ₹{(quantity * price).toLocaleString()}
                      </button>
                    </div>

                    <div className="shipping-info">
                      <span>🚚 Free Shipping</span>
                      <span>🐰 Cruelty Free</span>
                      <span>🌿 Organic</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-lg-12">
                <div className="bento-card desc-card">
                  {detail?.keyFeatures?.length > 0 && (
                    <KeyFeatures item={detail.keyFeatures} />
                  )}

                  <div
                    dangerouslySetInnerHTML={{ __html: description }}
                    style={{ fontFamily: "sans-serif", lineHeight: 1.6 }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {relatedProducts && relatedProducts.length > 0 && (
        <div className="flat-spacing-2" style={{ backgroundColor: "beige" }}>
          <div className="container product">
            <div className="flat-animate-tab flat-controltab-nav">
              <div className="flat-title text-start">
                <h4>Related Products</h4>
              </div>
              <div className="row">
                {relatedProducts.map((product, index) => (
                  <div
                    className="col-lg-3 col-sm-6 col-xs-6 mb-2"
                    key={product?._id || index}
                  >
                    <Product item={product} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {detail.video && (
        <div id="floating-video" className="floating-animate">
          <button
            onClick={() => {
              document.getElementById("floating-video").style.display = "none";
              setViewFixVideo(true);
            }}
          >
            ×
          </button>
          {detail.video.includes("youtube.com") ||
          detail.video.includes("youtu.be") ? (
            <iframe
              width="100%"
              height="180"
              src={`https://www.youtube.com/embed/${extractYouTubeID(detail.video)}`}
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="YouTube video"
            ></iframe>
          ) : (
            <video width="100%" height="180" controls autoPlay muted>
              <source src={detail.video} type="video/mp4" />
              Your browser does not support HTML5 video.
            </video>
          )}
        </div>
      )}
      <div className="offcanvas offcanvas-end" id="cartDrawer" tabIndex="-1">
        <CartCanvas />
      </div>

      <div className="tf-sticky-btn-atc show">
        <div className="container-2">
          <div className="tf-height-observer w-100 d-flex align-items-center">
            <div className="tf-sticky-atc-product d-flex align-items-center">
              <div className="tf-sticky-atc-img">
                <img src={mainImage} />
              </div>
              <div className="tf-sticky-atc-title fw-5 ">{title}</div>
            </div>
            <div
              className="tf-sticky-atc-infos"
              style={{ display: "contents" }}
            >
              {product?.productType !== "Single" && (
                <div className="tf-sticky-atc-variant-price text-center tf-select">
                  <select>
                    {variants.map((variant, index) => (
                      <option key={index}>{variant?.attributes?.colour}</option>
                    ))}
                  </select>
                </div>
              )}

              <div className="tf-sticky-atc-btns">
                {/* <div className="tf-product-info-quantity">
                  <div className="wg-quantity">
                    <button
                      className="btn-quantity minus-btn"
                      className="qty-btn"
                      onClick={(e) => setQuantity(quantity - 1)}
                    >
                      -
                    </button>
                    <input
                      className="quantity-product font-4"
                      type="text"
                      name="number"
                      value={quantity}
                      readOnly
                    />
                    <button
                      className="btn-quantity plus-btn  btn-increase"
                      onClick={(e) => setQuantity(quantity + 1)}
                    >
                      +
                    </button>
                  </div>
                </div> */}
                <div className="custom-cart-qty-toggle">
                  <button
                    className="btn-quantity btn-decrease"
                    onClick={(e) => {
                      e.preventDefault();
                      if (quantity > 1) setQuantity(quantity - 1);
                    }}
                  >
                    -
                  </button>
                  <input
                    // className="quantity-product"
                    type="text"
                    name="number"
                    value={quantity}
                    readOnly
                  />
                  <button
                    className="btn-quantity btn-increase"
                    onClick={(e) => setQuantity(quantity + 1)}
                  >
                    +
                  </button>
                </div>

                <a
                  href="#shoppingCartCanvas"
                  data-action="cart"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#cartDrawer"
                  onClick={handleAddToCart}
                  className="tf-btn animate-btn d-inline-flex justify-content-center"
                >
                  Add to cart
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DetailPage;

